import { moduleProviderFactory } from "core/providers";
 import { 
	FacilityInventoryCountList,
	FacilityInventoryCountDetailList,
	FacilityInventoryCountEdit,
	FacilityInventoryCountDetailEdit,
	FacilityInventoryCountDetailFullEdit,
	FacilityInventoryCountFileUpload
 } from "application/facility-inventory/pages";

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.facility-inventory",
				pattern: "/facility-inventory",
				children: [
					{
						name: "master.app.main.facility-inventory.list",
						pattern: "",
						tabTitle: "FACILITY_INVENTORY.LIST.TITLE_SECONDARY",
						component: FacilityInventoryCountList,
						authorization: "facilityOrderSection.read",
						data: {
							title: "FACILITY_INVENTORY.LIST.TITLE_SECONDARY",
						},
					},
					{
						name: "master.app.main.facility-inventory.create",
						pattern: "/create",
						tabTitle: "Create Facility Inventory",
						component: FacilityInventoryCountEdit,
						authorization: "facilityOrderSection.create",
						data: {
							back: "master.app.main.facility-inventory.list",
							title: "FACILITY_INVENTORY.EDIT.TITLE",
						},
					},
					{
						name: "master.app.main.facility-inventory.edit",
						pattern: "/edit/:id",
						tabTitle: "Edit Facility Inventory",
						component: FacilityInventoryCountEdit,
						authorization: "facilityOrderSection.update",
						data: {
							back: "master.app.main.facility-inventory.list",
							title: "FACILITY_INVENTORY.EDIT.TITLE",
						},
					},
					{
						name: "master.app.main.facility-inventory.facility-inventory-detail.list",
						pattern: "/:facilityInventoryCountHeaderId/details",
						authorization: "facilityOrderSection.read",
						component: FacilityInventoryCountDetailList,
						data: {
							back: "master.app.main.facility-inventory.list",
							title: "FACILITY_INVENTORY_DETAIL.LIST.TITLE",
							crumbs: {
								title: "FACILITY_INVENTORY_DETAIL.CRUMB.FACILITY_INVENTORY",
								route: 'master.app.main.facility-inventory.facility-inventory-detail.list'
							}
						},					
					},
					{
						name: "master.app.main.facility-inventory.facility-inventory-detail.create",
						pattern: "/:facilityInventoryCountHeaderId/create",
						authorization: "facilityOrderSection.read",
						component: FacilityInventoryCountDetailEdit,
						data: {
							back: "master.app.main.facility-inventory.facility-inventory-detail.list",
							title: "FACILITY_INVENTORY_DETAIL.LIST.TITLE",
						},					
					},
					{
						name: "master.app.main.facility-inventory.facility-inventory-detail.edit",
						pattern: "/:facilityInventoryCountHeaderId/edit/:id",
						tabTitle:'Edit Facility Inventory',
						authorization: "facilityOrderSection.read",
						component: FacilityInventoryCountDetailFullEdit,
						data: {
							back: "master.app.main.facility-inventory.facility-inventory-detail.list",
							title: "FACILITY_INVENTORY_DETAIL.LIST.TITLE",
						},					
					},
					{
						name: "master.app.main.facility-inventory.file-upload",
						pattern: "/:facilityInventoryCountHeaderId/file-upload",
						tabTitle: "FACILITY_INVENTORY.FILE_UPLOAD.TITLE",
						authorization: "facilityOrderSection.read",
						component: FacilityInventoryCountFileUpload,
						data: {
							back: "master.app.main.facility-inventory.facility-inventory-detail.list",
							title: "FACILITY_INVENTORY.FILE_UPLOAD.TITLE",
							crumbs: {
								title: "FACILITY_INVENTORY_DETAIL.CRUMB.IMPORT",
								route: 'master.app.main.facility-inventory.file-upload'
							}
						},
					}
				],
			},
		],
		menu: [
			{
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: 'coreUserSection.read',
				order: 5,
				subMenu: [
					{
						title: "MENU.FACILITY_INVENTORIES_SUB",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.facility-inventory.list",
						order: 4
					},
				]
			}
		],
	});
})();
